import React from "react";
import { Reveal } from "../components/Reveal";
import { PageHero, CtaBand, SectionHead } from "../components/UI";
import {
  IconBuilding,
  IconBriefcase,
  IconUsers,
  IconLayers,
  IconCheck,
  IconClock,
  IconDoc,
  IconTask,
} from "../components/Icons";

const audiences = [
  {
    ic: <IconBuilding size={22} />,
    name: "Cơ quan hành chính",
    pain: "Họp giao ban, họp chuyên đề liên tục; biên bản và kết luận phải chuẩn hoá, trình ký đúng hạn.",
    points: [
      "Sinh dự thảo kết luận theo bố cục hành chính chuẩn",
      "Bóc tách nhiệm vụ giao cho phòng ban kèm thời hạn",
      "Lưu trữ tập trung, có nhật ký phục vụ kiểm tra",
    ],
  },
  {
    ic: <IconUsers size={22} />,
    name: "Văn phòng & thư ký",
    pain: "Mất hàng giờ nghe lại ghi âm, gõ lại biên bản và tổng hợp ý kiến từng người.",
    points: [
      "Phiên âm tự động, phân biệt người nói",
      "Tóm tắt ý chính, dòng thời gian thảo luận",
      "Xuất Word/PDF chỉ với vài thao tác",
    ],
  },
  {
    ic: <IconBriefcase size={22} />,
    name: "Doanh nghiệp & tổ chức",
    pain: "Quyết định trong họp dễ trôi; thiếu cơ chế theo dõi ai làm gì, đến khi nào.",
    points: [
      "Danh sách nhiệm vụ có người phụ trách rõ ràng",
      "Biên bản nhất quán theo mẫu của tổ chức",
      "Tra cứu nhanh theo cuộc họp, thời gian, người nói",
    ],
  },
  {
    ic: <IconLayers size={22} />,
    name: "Ban quản lý dự án",
    pain: "Nhiều cuộc họp tiến độ; cần nắm cam kết và mốc thời gian của từng bên.",
    points: [
      "Trích quyết định và cam kết theo từng đầu việc",
      "Theo dõi nhiệm vụ và thời hạn xuyên suốt dự án",
      "Hồ sơ họp đầy đủ, minh bạch để đối soát",
    ],
  },
];

export function Solutions() {
  return (
    <>
      <PageHero
        eyebrow="Giải pháp theo ngành"
        title="Một nền tảng, phù hợp với cách mỗi tổ chức tổ chức cuộc họp"
        sub="Từ cơ quan hành chính đến doanh nghiệp và ban quản lý dự án — Ghi Âm Pro thích ứng với nghiệp vụ họp của bạn."
      />

      <section className="section">
        <div className="container">
          {audiences.map((a, i) => (
            <Reveal key={i} className="audience-row" delay={(i % 2) * 60}>
              <div>
                <span className="ic who-ic">{a.ic}</span>
                <h3>{a.name}</h3>
              </div>
              <div>
                <p className="lead" style={{ marginBottom: 16 }}>
                  {a.pain}
                </p>
                <div className="ticks" style={{ marginTop: 0 }}>
                  {a.points.map((p, j) => (
                    <div className="tick" key={j}>
                      <span className="ck">
                        <IconCheck size={15} />
                      </span>
                      <span>{p}</span>
                    </div>
                  ))}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="section soft">
        <div className="container">
          <SectionHead
            center
            eyebrow="Tình huống sử dụng"
            title="Những cuộc họp mà Ghi Âm Pro phát huy nhất"
          />
          <div className="grid cards-3">
            {[
              [<IconClock size={22} />, "Họp giao ban định kỳ", "Tổng hợp tiến độ, chốt nhiệm vụ tuần/tháng và theo dõi liên tục."],
              [<IconDoc size={22} />, "Họp chuyên đề, thẩm định", "Lưu lại lập luận, ý kiến từng bên và kết luận của chủ trì."],
              [<IconTask size={22} />, "Họp triển khai dự án", "Ghi nhận cam kết, mốc thời gian và phân công cụ thể."],
            ].map(([ic, h, p], i) => (
              <Reveal className="card" key={i} delay={i * 70}>
                <div className="ic">{ic as React.ReactNode}</div>
                <h3>{h as string}</h3>
                <p>{p as string}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <CtaBand
        title="Giải pháp cho đúng cách bạn họp"
        sub="Chia sẻ quy trình họp của đơn vị, chúng tôi sẽ tư vấn cấu hình phù hợp và demo trên tình huống thực tế."
      />
    </>
  );
}
